module.exports = __webpack_public_path__ + "img/aParty_110523_G.94ebf11b.jpg";